import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-24 bg-warm-100 px-6" data-id="element-124">
      <div className="max-w-2xl mx-auto" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-126">
          <h2 className="text-3xl md:text-4xl font-bold text-warm-900 mb-8 font-display" data-id="element-127">
            “No sé qué comer.”
          </h2>

          <div className="space-y-6 text-lg text-warm-900/90 leading-relaxed" data-id="element-128">
            <p data-id="element-129">
              No es flojera. No es falta de disciplina.{' '}
              <span className="font-semibold text-teal-600" data-id="element-130">Es fricción.</span>
            </p>

            <p data-id="element-131">
              Cuando cada comida exige pensar, decidir, cocinar, lavar,
              resistir… estás pidiéndote una heroicidad diaria.
            </p>

            <p data-id="element-132">
              Y lo peor: como te importa “hacerlo bien”, te metes a planes que
              prometen orden… pero te cobran con más carga mental.
            </p>

            <div className="pl-6 border-l-4 border-teal-600/30 my-8 space-y-2 italic text-warm-900/70" data-id="element-133">
              <p data-id="element-134">Recetas largas.</p>
              <p data-id="element-135">Ingredientes raros.</p>
              <p data-id="element-136">Tres horas el domingo.</p>
            </div>

            <p className="font-medium" data-id="element-137">
              Y una semana después, delivery otra vez.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}